export default {
  ApplicationInfo: '申請情報',
  Game: 'ゲーム',
  Account: 'アカウント',
  Server: 'サーバー',
  CharacterName: 'キャラクター',
  PlatformOrderNumber: 'プラットフォーム注文番号',
  Amount: '金額',
  InvoiceMethod: 'インボイス発行方法',
  InvoiceByTotalOrderAmount: '注文総額でインボイスを発行',
  InvoiceByOrderAmountSeparately: '注文金額ごとに個別でインボイスを発行',
  PhoneNumber: '連絡先電話番号',
  Name: '名前',
  Address: '住所',
  InvoiceTitle: 'インボイスの宛名',
  PersonalTitleOnlyNoCompany:
    '個人宛てのみ対応しており、法人宛ては承っておりません',
  ReceivingEmail: '受信メールアドレス',
  Remarks: '備考',
  InputContent: '入力内容',
  ApplicationSubmittedSuccessfully: '申請が正常に送信されました',
  InvoiceApplicationSubmittedSuccessfully:
    'インボイスの申請が正常に送信されました。\r\nスタッフが7営業日以内に処理いたしますので、メールをご確認ください。',
  Confirm: '確定',
  Submit: '提出',
  ApplicationSubmissionFailed: '申請の提出に失敗しました',
  InvoiceApplicationFailed:
    'インボイスの申請提出に失敗しました。更新して再試行するか、カスタマーサポートにお問い合わせください。',
  InvoiceApplicationSubmitted:
    'インボイスの申請が完了いたしました。重複して申請しないようご注意ください。',
  PleaseEnterName: '名前を入力してください',
  PleaseEnterAddress: '住所を入力してください',
  PleaseEnterInvoiceTitle: 'インボイスの宛名を入力してください',
  PleaseEnterEmail: '受信用メールアドレスを入力してください',
  PleaseEnterRemarks: '備考を入力してください',
  NumberParsingError: '番号解析エラー',
  PleaseEnterValidEmailFormat: '有効なメールアドレス形式をご入力ください',
  IncompleteInformation: '情報が不完全です。ご確認をお願いいたします',
  ExpandAll: '全て展開'
};
